var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabs',{staticClass:"search-results-tabs",on:{"changed":_vm.tabChanged}},[_c('tab',{attrs:{"title":"PRODUCTS"}}),_c('tab',{attrs:{"title":"BLOG"}}),_c('tab',{attrs:{"title":"PAGES"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }